import { X } from 'lucide-react';
import type { EntityConfig } from '@/lib/entity-config';

interface HeaderProps {
  entity: EntityConfig;
  actions?: React.ReactNode;
  onClose?: () => void;
}

export function Header({ entity, actions, onClose }: HeaderProps) {
  return (
    <header className="border-b border-ck-dark-border bg-black">
      <div className="flex items-center justify-between px-6 py-4">
        <div className="flex items-center gap-4">
          <h1 className="text-2xl font-bold text-ck-cyan">
            {entity.title}
          </h1>
        </div>

        <div className="flex items-center gap-3">
          {actions}
          {onClose && (
            <button
              onClick={onClose}
              className="text-muted-foreground transition-colors hover:text-foreground"
            >
              <X className="h-6 w-6" />
            </button>
          )}
        </div>
      </div>
    </header>
  );
}